/**
 * DEPLOY-ЫН ЗӨРҮҮГ ТАНИХ, ӨӨРӨӨ ЭДГЭХ.
 *
 * ! 🔴 ЯМАР АСУУДАЛ ВЭ: `next build` бүрд chunk-ийн хаш шинэчлэгддэг бөгөөд
 * ! ажиллаж буй сервер ЗӨВХӨН сүүлийн багцыг хадгална. Хуудсаа нээчихээд
 * ! байтал deploy болбол хөтөч дээрх хуучин JS нь байхгүй болсон chunk,
 * ! Server Action дуудаж, React-ийн алдааны хаалт ажиллана.
 *
 * ! 🔴 ЯАГААД ӨӨРӨӨ ЗАСАГДДАГГҮЙ БАЙВ: хаалтын «Дахин оролдох» товч нь
 * ! `reset()` дуудна — тэр нь МӨЧЛӨГИЙГ дахин зурдаг болохоос БАРИМТ
 * ! БИЧГИЙГ дахин ачаалдаггүй. Хуучин JS санах ойд хэвээр үлдэх тул дараагийн
 * ! оролдлого ЯГ ИЖИЛ алдаа өгнө — хэрэглэгч мөнхийн давталтад ордог.
 * ! Production логд 2026-09-15-нд `Failed to find Server Action` 53 удаа
 * ! бичигдсэн байв; програмын алдаа (TypeError г.м.) НЭГ Ч удаа алга.
 *
 * ! Тиймээс энэ ангийн алдааг ТАНИЖ, баримт бичгийг бүтнээр ачаална.
 */

/** Deploy-ын зөрүүнээс үүдэх алдааны шинжүүд. */
const STALE_PATTERNS =
  /Failed to find Server Action|ChunkLoadError|Loading chunk \d+ failed|error loading dynamically imported module|MODULE_NOT_FOUND/i

const RELOAD_STAMP = 'coresoft.stale-reload-at'

/** Нэг зөрүүнд НЭГ л удаа ачаална — эс бөгөөс жинхэнэ алдаа давталт болно. */
const RELOAD_GUARD_MS = 30_000

export const isStaleDeploymentError = (error: unknown): boolean => {
  if (!error) return false

  const probe = error instanceof Error ? `${error.name} ${error.message}` : String(error)

  return STALE_PATTERNS.test(probe)
}

/**
 * Зөрүүний алдаа мөн бол баримт бичгийг дахин ачаална.
 *
 * ! Буцаах утга: ачаалах гэж байгаа эсэх. `false` бол дуудагч энгийн
 * ! алдааны дэлгэцээ харуулна.
 *
 * ! ХАМГААЛАЛТ: `sessionStorage`-д тамга тавина. Дахин ачаалсны дараа ч
 * ! ижил алдаа гарвал (жинхэнэ согог) хоёр дахь удаа ачаалахгүй — хэрэглэгч
 * ! хязгааргүй анивчих дэлгэц харахын оронд алдааг нь харна.
 */
export const reloadIfStale = (error: unknown): boolean => {
  if (typeof window === 'undefined' || !isStaleDeploymentError(error)) return false

  try {
    const last = Number(window.sessionStorage.getItem(RELOAD_STAMP) ?? 0)

    if (Number.isFinite(last) && Date.now() - last < RELOAD_GUARD_MS) return false

    window.sessionStorage.setItem(RELOAD_STAMP, String(Date.now()))
  } catch {
    /* ! Хувийн горимд `sessionStorage` шиднэ — тэр үед ачаалахгүй өнгөрнө. */
    return false
  }

  window.location.reload()

  return true
}
